diy.angular.registerDirective('diyfminlineedit', [ 
function() {
    
    var $ = jQuery;
    
    function startInlineEdit(el, value) {
        var input, self = this;
        
        function removeInlineEdit() {
            // cleanup to prevent memory leaks
            input.unbind('.fminlineedit');
            input.remove();
            if (self.textarea) {
                el.css('height', '');
            }
            el.removeClass('fm-inline-edited');
            input = null;
            el = null;
        }
        
        function endInlineEdit() {
            var val = input.val();
            removeInlineEdit(input, el)
            self.end && self.end(val); 
            self = null;
        }
        
        function cancelInlineEdit() {
            removeInlineEdit(input, el);
            self.cancel && self.cancel();
            self = null;
        }
        if (this.textarea) {
            input = $('<textarea />');
        } else {
            input = $('<input type="text" />');
        }
        input.addClass('fm-inline-edit').appendTo(el).val(value);
        if (this.placeholder) {
            input.attr('placeholder', this.placeholder);
        }
        el.addClass('fm-inline-edited');
        
        
        input.bind('blur.fminlineedit', function(ev) {
            endInlineEdit();
        }).bind('keydown.fminlineedit', function(ev) {
            if (13 === ev.which) { // ENTER key
                endInlineEdit();
            } else if (27 === ev.which) { // ESCAPE key
                cancelInlineEdit();
            } else if (self.textarea) {
                // autogrow
                el.height(input[0].scrollHeight);
            }
            ev.stopPropagation();
        }).bind('click.fminlineedit focus.fminlineedit keypress.fminlineedit', function(ev) {
            // otherwise events will propagate to their parents which may catch
            // them and the parents may return false, disabling these events
            // example: jQuery.ui.dialog compares some zIndexes and disables keydown events
            ev.stopPropagation();
        });
        input.focus();
    }

    return {
        restrict: 'A',
        link: function(scope, elem, attr) {

            var $elem = $(elem);
            
            var getConfig = function() {
                return scope.$eval(attr.diyfminlineedit);
            }
            
            var unWatch = scope.$watch(getConfig, function(config){
                if (config) {
                    config.start = function(value) {
                        if ('function' === typeof config.beforeStart) {
                            config.beforeStart();
                        }
                        startInlineEdit.call(config, $elem, value);
                    };
                    unWatch();
                }
            });
            
            scope.$on('$destroy', function(){
                // cleanup to prevent memory leaks
                $elem = null;
                attr = null;
            });
        }
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfminlineedit.js
 ** module id = 979
 ** module chunks = 0
 **/